<script lang="tsx" setup>
import { ref } from "vue"
import ExternalLink from "@/components/Links/ExternalLink.vue"
import TextLabel from "../Text/TextLabel.vue"

defineProps<{
  email?: string
  website?: string
  instagram?: string
}>()

const copied = ref(false)

async function handleEmailClick(email: string) {
  try {
    await navigator.clipboard.writeText(email.trim())
    copied.value = true
    setTimeout(() => (copied.value = false), 2000)
  } catch {
    // clipboard write failed — mailto still opens
  }
}
</script>

<template>
  <div class="flex-col">
    <TextLabel>Contact:</TextLabel>
    <div v-if="email">
      <a
        :href="`mailto:${email.trim()}`"
        class="link"
        @click="handleEmailClick(email!)"
      >
        {{ copied ? "Copied!" : "Email" }}
      </a>
    </div>
    <div v-if="website">
      <ExternalLink :href="website" :text="'Website'" />
    </div>
    <div v-if="instagram">
      <ExternalLink :href="instagram" :text="'Instagram'" />
    </div>
  </div>
</template>
